<template>
  <div class="body">

  </div>
</template>

<script>

import {setToken, weixinLoginUrl} from "@/utils/auth";
import weixinApi from "@/api/weixinApi";

export default {
  name: "login",
  data() {
    return {}
  },
  created() {
    this.login()
  },
  methods: {
    login() {
      if (this.$route.query.code === undefined) {
        window.location.href = weixinLoginUrl()
      } else {
        const toast = this.$toast.loading({
          message: '自动登录中...',
          forbidClick: true,
        });
        weixinApi.getToken({'accesskey': this.$route.query.code}).then(res => {
          setToken(res.token)
          toast.clear()
          this.$router.push({path: '/'})
        }).catch(err => {
          // eslint-disable-next-line no-console
          console.log(err.data.message)
          toast.clear()
        })
      }
    }
  }
}
</script>

<style>

.body {
  text-align: center;
  height: 100vh;
  line-height: 90vh;
}

</style>
